module.exports = __webpack_public_path__ + "static/a-xx-171-art-438ebb47bff18f09c0e3f066dd4f9de6.jpg";